import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-philosophycards',
  templateUrl: './philosophycards.component.html',
  styleUrls: ['./philosophycards.component.css']
})
export class PhilosophycardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
